import React from 'react'
import Contact from '../Contacts/contactFr'
import ContactMail from '../Contacts/contactMailFr'
import HeroContact from '../HeroContactFr';
import Footer from '../../Footer/FooterFr';
import '../../App.css';


function ContactPage () {
    return (
        <div>
           <HeroContact/>
           <Contact/>
           <ContactMail/>
           <Footer />
        </div>
    );
}

export default ContactPage;